import './App.css';
import { BrowserRouter as Router, Switch, Route, withRouter, NavLink,browserHistory } from 'react-router-dom';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

import Main from './pages/Main';
import AssetDetails from './pages/AssetDetails';
import Collection from './pages/Collection';
import UserCollections from './pages/UserCollections';
import CollectionsByUser from './pages/CollectionsByUser';
import CreateCollection from './pages/CreateCollection';
import ImportCollection from './pages/ImportCollection';
import CreateNft from './pages/CreateNft';
import NonMintedNft from './pages/NonMintedNft';
import Login from './pages/Login';
import Checkout from './pages/Checkout';
import NftCreationOption from './pages/NftCreationOption';
import UserProfile from './pages/UserProfile';
import NftsByUser from './pages/NftsByUser';
import FavoritesNftsByUser from './pages/FavoritesNftsByUser';
import Category from './pages/Category';
import SuccessMint from './pages/SuccessMint';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
            <Switch>
              <Route exact path="/" component={Main} />
              <Route  path="/collection" component={Collection} />
              <Route  path="/success" component={SuccessMint} />
              <Route  path="/profile/:id" component={UserProfile} />
              <Route  path="/my-nfts" component={NftsByUser} />
              <Route  path="/my-favorites" component={FavoritesNftsByUser} />
              <Route  path="/checkout" component={Checkout} />
              <Route  path="/user-collections/:id" component={CollectionsByUser} />
              <Route  path="/collections/:id/:name" component={UserCollections} />
              <Route  path="/category/:id/:name" component={Category} />
              <Route  path="/create-collection" component={CreateCollection} />
              <Route  path="/import-collection" component={ImportCollection} />
              <Route  path="/mint-nft" component={CreateNft} />
              <Route  path="/non-minted-nft" component={NonMintedNft} />
              <Route  path="/create-nft" component={NftCreationOption} />
              <Route path="/asset/:collectionId/:nftId" component={AssetDetails} />
              <Route path="/session/:id" component={Login} />

              
            </Switch>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
